import { checkBrowserVersion } from '@cs-cms/utils';
import React, { ReactNode } from 'react';
import { UnsupportedBrowserPage } from '../pages/UnsupportedBrowserPage';
import { useUIConfig } from '../UiProvider';

interface Props {
  children: ReactNode;
}

export const BrowserGuard: React.FC<Props> = ({ children }) => {
  const { minimumBrowserVersions } = useUIConfig();
  const browserCheck = checkBrowserVersion(minimumBrowserVersions);

  if (!browserCheck.supported) {
    return <UnsupportedBrowserPage browserInfo={browserCheck} />;
  }

  return <>{children}</>;
};
